export default "__VITE_ASSET__B3$gUt1$__"